import React from 'react'
import { Route, Switch } from 'react-router-dom'

import LoginPage from 'components/login/login_page'

import DashboardPage from 'components/dashboard/dashboard_page'
import UserSearchPage from 'components/user_search/user_search_page'

import OrganizationsPage from 'components/organization/organizations_page'
import InstitutionsPage from 'components/institution/institutions_page'
import RequestFormIssuancesPage from 'components/request_form_issuance/request_form_issuances_page'
import EditRequestFormsPage from 'components/request_form/edit_request_forms_page'
import PreviewRequestFormPage from 'components/request_form_issuance/preview_request_form'
import PreviewRequestFormHomeTestPage from 'components/request_form_issuance/preview_request_form_home_test'
import PatientsPage from 'components/patient/patients_page'
import DoctorsPage from 'components/doctor/doctors_page'
import VendorsPage from 'components/vendor/vendors_page'

import SamplesPage from 'components/sample/samples_page'
import AnalyticsSamplesPage from 'components/sample/analytics_samples_page'
import PickingSamplesPage from 'components/extraction/picking_samples'
import ExtractionPage from 'components/extraction/extraction_page'
import ExperimentSheetPage from 'components/extraction/experiment_sheet_page'
import DnaListPage from 'components/dna/dna_list_page'

import ProbesPage from 'components/probe/probes_page'
import ProbeLotsPage from 'components/probe_lot/probe_lots_page'
import ProbeStocksPage from 'components/probe_stock/probe_stocks_page'
import StocktakingsPage from 'components/stocktaking/stocktakings_page'
import StocktakingItemsPage from 'components/stocktaking_item/stocktaking_items_page'
import PcrProtocolsPage from 'components/pcr_protocol/pcr_protocols_page'
import CustomerOrdersPage from 'components/customer_order/customer_orders_page'
import HomeProductsPage from 'components/home_product/home_products_page'
import OrdersPage from 'components/order/thermo_orders_page'

import PcrRunsPage from 'components/pcr_run/pcr_runs_page'
import PcrRunPage from 'components/pcr_run/pcr_run_384_page'
import PcrProcessLogsPage from 'components/pcr_process_log/pcr_process_logs_page'
import PcrTestRunsPage from 'components/pcr_test_run/pcr_test_runs_page'
import PcrTestResultsPage from 'components/pcr_test_run/preview_test_results'
import PrintRequestPage from 'components/print_request/print_requests_page'
import SendHistoriesPage from 'components/send_history/send_histories_page'
import PreviewResultPage from 'components/send_history/preview_results'
import PreviewRequestListPage from 'components/send_history/preview_request_list'
import PreviewRequestPostListPage from 'components/send_history/preview_request_post_list'

import ReceiptPage from 'components/inspection/receipt_page'
import InputPage from 'components/inspection/input_page'
import ConfirmPage from 'components/inspection/confirm_page'
import RequestFormErrorsPage from 'components/request_form_error/request_form_errors_page'

import TransportationReportsPage from 'components/transportation_report/transportation_reports_page'
import FreezerPage from 'components/freezer/freezer_page'
import TranscriptionHistoriesPage from 'components/transcription_history/transcription_histories_page'

import ProductItemsPage from 'components/product_item/product_items_page'
import ProductSetsPage from 'components/product_set/product_sets_page'
import ProtocolVersionsPage from 'components/protocol_version/protocol_versions_page'
import QcVersionsPage from 'components/protocol_version/qc_versions_page'

import TagsPage from 'components/tag/tags_page'

import SalesPage from 'components/sales/sales_page'
import SalesDashboardPage from 'components/sales/sales_dashboard_page'
import SalesAgenciesPage from 'components/sales_agency/sales_agencies_page'
import InvoicesPage from 'components/sales/invoice_page'
import SalesAgencyPaymentPage from 'components/sales/sales_agency_payment_page'
import CouponsPage from 'components/coupon/coupons_page'
import CouponCodeHistoriesPage from 'components/coupon_code/coupon_code_histories'
import PreviewCouponCodesPage from 'components/coupon_code/preview_coupon_codes'
import MaterialsPage from 'components/material/materials_page'
import DiscountsPage from 'components/discount/discounts_page'

import CtChartPage from 'components/report/ct_chart_page'

import { Error404Page } from 'components/shared/error_404'
import UserAuth from '../containers/user_auth'
import Layout from 'components/shared/layout'
import MasterDataContainer from 'containers/master_data_container'

import StandardUrinesPage from 'components/standard_urine/standard_urnies_page'

import DisposalLedgerPage from 'components/ledger/disposal/disposal_ledger_page'
import RequestFormErrorLedgerPage from 'components/ledger/repest_form_error/request_form_error_ledger_page'
import ReagentLedgerPage from 'components/ledger/reagent/reagent_ledger_page'
import MaintenanceLedgerPage from 'components/ledger/equipment/maintenance_ledger/maintenance_ledger_page'
import EquipmentsPage from 'components/equipment/equipment_page'
import TemperatureLedgerPage from 'components/temperature_ledger/temperature_ledger_page'
import TrainingLedgerPage from 'components/training_ledger/training_ledger_page'
import GroupTrainingPage from 'components/group_training_ledger/group_training_page'
import GroupTrainingLedgerPage from 'components/group_training_ledger/group_training_ledger_page'
import TrainingContentsPage from 'components/training_content/training_contents_page'
import QcLedgersPage from 'components/qc_ledger/qc_ledgers_page'
import QcLedgerPage from 'components/ledger/qc/qc_ledger_page'

import ReagentsPage from 'components/reagent/reagents_page'
import ReagentItemsPage from 'components/reagent_item/reagent_items_page'
import ReceiveLedgerPage from 'components/receive_ledger/receive_ledger_page'
import CheckInLedgerPage from 'components/check_in_ledger/check_in_ledger_page'

import TaskMasterSetsPage from 'components/task_master_set/task_master_sets_page'
import TaskSetsPage from 'components/task_set/task_sets_page'
import TasksPage from 'components/task/tasks_page'
import TaskGroupsPage from 'components/task_group/task_groups_page'
import MaterialTasksPage from 'components/task/material_tasks_page'
import PrintMaterialTasksPage from 'components/task/print_material_tasks_page'
import MeasureLedgerPage from 'components/measure_ledger/measure_ledger_page'
import MeasureLedgerPaperPage from 'components/measure_ledger/measure_ledger_paper_page'
import TrainingLedgerPaperPage from 'components/training_ledger/training_ledger_paper_page'

import PcrRunProtocolSheet from 'components/pcr_run/pcr_run_protocol_sheet'
import TestResultV2 from 'components/send_history/test_view/test_result_v2'
import NaviResultsPage from 'components/navi/results/NaviResultsPage'
import NaviResultDetailPage from 'components/navi/results/NaviResultDetailPage'
import NaviPostageSlipsPage from 'components/navi/results/NaviPostageSlipsPage'
import LiteResultsPage from 'components/lite/results/LiteResultsPage'
import LiteResultDetailPage from 'components/lite/results/LiteResultDetailPage'
import LitePostageSlipsPage from 'components/lite/results/LitePostageSlipsPage'
import TestResultLite from 'components/send_history/test_view/test_result_lite'
import CheckResultsPage from 'components/check/results/CheckResultsPage'
import CheckResultDetailPage from 'components/check/results/CheckResultDetailPage'
import CheckPostageSlipsPage from 'components/check/results/CheckPostageSlipsPage'
import TestResultCheck from 'components/send_history/test_view/test_result_check'

const AppRoutes: React.FC = () => {
    const craifAppContent = (
        <>
            <UserAuth>
                <MasterDataContainer>
                    <Layout>
                        <Switch>
                            <Route exact path={AppRouteHelper.dashboards()}>
                                <DashboardPage />
                            </Route>
                            <Route exact path={AppRouteHelper.userSearch()}>
                                <UserSearchPage />
                            </Route>

                            <Route exact path={AppRouteHelper.organizations()}>
                                <OrganizationsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.institutions()}>
                                <InstitutionsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.requestFormIssuances()}>
                                <RequestFormIssuancesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.requestForms()}>
                                <EditRequestFormsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.previewRequestForm()}>
                                <PreviewRequestFormPage />
                            </Route>
                            <Route exact path={AppRouteHelper.previewRequestFormHomeTest()}>
                                <PreviewRequestFormHomeTestPage />
                            </Route>
                            <Route exact path={AppRouteHelper.patients()}>
                                <PatientsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.doctors()}>
                                <DoctorsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.vendors()}>
                                <VendorsPage />
                            </Route>

                            {/* Experiment */}
                            {/* Sample */}
                            <Route exact path={AppRouteHelper.samples()}>
                                <SamplesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.analyticsSamples()}>
                                <AnalyticsSamplesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pickingSamples()}>
                                <PickingSamplesPage />
                            </Route>
                            {/* Extraction */}
                            <Route exact path={AppRouteHelper.extractions()}>
                                <ExtractionPage />
                            </Route>
                            <Route exact path={AppRouteHelper.experimentSampleSheet()}>
                                <ExperimentSheetPage />
                            </Route>
                            {/* DNA */}
                            <Route exact path={AppRouteHelper.dnaList()}>
                                <DnaListPage />
                            </Route>

                            {/* PCR */}
                            <Route exact path={AppRouteHelper.pcrRuns()}>
                                <PcrRunsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pcrRun()}>
                                <PcrRunPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pcrProcessLogs()}>
                                <PcrProcessLogsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.pcrTestRuns()}>
                                <PcrTestRunsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pcrTestResults()}>
                                <PcrTestResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pcrRunProtocolSheet()}>
                                <PcrRunProtocolSheet />
                            </Route>

                            <Route exact path={AppRouteHelper.probes()}>
                                <ProbesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.probeLots()}>
                                <ProbeLotsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.probeStocks()}>
                                <ProbeStocksPage />
                            </Route>
                            <Route exact path={AppRouteHelper.stocktakings()}>
                                <StocktakingsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.stocktakingItems()}>
                                <StocktakingItemsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.customerOrders()}>
                                <CustomerOrdersPage />
                            </Route>
                            <Route exact path={AppRouteHelper.homeProducts()}>
                                <HomeProductsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.orders()}>
                                <OrdersPage />
                            </Route>
                            <Route exact path={AppRouteHelper.pcrProtocols()}>
                                <PcrProtocolsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.printRequests()}>
                                <PrintRequestPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistories()}>
                                <SendHistoriesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewResults()}>
                                <PreviewResultPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewRequestList()}>
                                <PreviewRequestListPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewRequestPostList()}>
                                <PreviewRequestPostListPage />
                            </Route>

                            {/* Inspection */}
                            <Route exact path={AppRouteHelper.inspectionTransportationReport()}>
                                <TransportationReportsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.inspectionReceipt()}>
                                <ReceiptPage />
                            </Route>
                            <Route exact path={AppRouteHelper.inspectionInput()}>
                                <InputPage />
                            </Route>
                            <Route exact path={AppRouteHelper.inspectionConfirm()}>
                                <ConfirmPage />
                            </Route>
                            <Route exact path={AppRouteHelper.requestFormErrors()}>
                                <RequestFormErrorsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.freezers()}>
                                <FreezerPage />
                            </Route>

                            <Route exact path={AppRouteHelper.transcriptionHistories()}>
                                <TranscriptionHistoriesPage />
                            </Route>

                            <Route exact path={AppRouteHelper.productItems()}>
                                <ProductItemsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.productSets()}>
                                <ProductSetsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.standardUrines()}>
                                <StandardUrinesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.protocolVersions()}>
                                <ProtocolVersionsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.qcSettings()}>
                                <QcVersionsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.tags()}>
                                <TagsPage />
                            </Route>

                            {/* 管理台帳 */}
                            <Route exact path={AppRouteHelper.temperatureLedger()}>
                                <TemperatureLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.trainingLedger()}>
                                <TrainingLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.trainingLedgerPaper()}>
                                <TrainingLedgerPaperPage />
                            </Route>
                            <Route exact path={AppRouteHelper.groupTraining()}>
                                <GroupTrainingPage />
                            </Route>
                            <Route exact path={AppRouteHelper.groupTrainingLedger()}>
                                <GroupTrainingLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.trainingContents()}>
                                <TrainingContentsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.sales()}>
                                <SalesPage />
                            </Route>

                            <Route exact path={AppRouteHelper.salesDashboard()}>
                                <SalesDashboardPage />
                            </Route>
                            <Route exact path={AppRouteHelper.salesAgencies()}>
                                <SalesAgenciesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.invoices()}>
                                <InvoicesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.salesAgencyPayment()}>
                                <SalesAgencyPaymentPage />
                            </Route>
                            <Route exact path={AppRouteHelper.coupons()}>
                                <CouponsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.couponCodeHistories()}>
                                <CouponCodeHistoriesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.previewCouponCode()}>
                                <PreviewCouponCodesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.materials()}>
                                <MaterialsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.discounts()}>
                                <DiscountsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.reportCtChart()}>
                                <CtChartPage />
                            </Route>

                            <Route exact path={AppRouteHelper.disposalLedger()}>
                                <DisposalLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.requestFormErrorsLedger()}>
                                <RequestFormErrorLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.reagentsLedger()}>
                                <ReagentLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.qcLedgers()}>
                                <QcLedgersPage />
                            </Route>
                            <Route exact path={AppRouteHelper.qcLedger()}>
                                <QcLedgerPage />
                            </Route>

                            <Route exact path={AppRouteHelper.checkInLedger()}>
                                <CheckInLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.receiveLedger()}>
                                <ReceiveLedgerPage />
                            </Route>

                            <Route exact path={AppRouteHelper.maintenanceLedgers()}>
                                <MaintenanceLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.measureLedger()}>
                                <MeasureLedgerPage />
                            </Route>
                            <Route exact path={AppRouteHelper.measureLedgerPaper()}>
                                <MeasureLedgerPaperPage />
                            </Route>
                            <Route exact path={AppRouteHelper.reagents()}>
                                <ReagentsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.reagentItems()}>
                                <ReagentItemsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.equipments()}>
                                <EquipmentsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.equipmentCategories()}>
                                <EquipmentsPage />
                            </Route>

                            <Route exact path={AppRouteHelper.taskMasterSets()}>
                                <TaskMasterSetsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.taskSets()}>
                                <TaskSetsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.tasks()}>
                                <TasksPage />
                            </Route>
                            <Route exact path={AppRouteHelper.taskGroups()}>
                                <TaskGroupsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.materialTasks()}>
                                <MaterialTasksPage />
                            </Route>
                            <Route exact path={AppRouteHelper.printMaterialTask()}>
                                <PrintMaterialTasksPage />
                            </Route>

                            <Route exact path={AppRouteHelper.testResultV2()}>
                                <TestResultV2 />
                            </Route>
                            <Route exact path={AppRouteHelper.naviResults()}>
                                <NaviResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.naviResultDetail()}>
                                <NaviResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.naviPostageSlips()}>
                                <NaviPostageSlipsPage />
                            </Route>

                            {/* ライト結果発送 */}
                            <Route exact path={AppRouteHelper.liteResults()}>
                                <LiteResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.liteResultDetail()}>
                                <LiteResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.litePostageSlips()}>
                                <LitePostageSlipsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.testResultLite()}>
                                <TestResultLite />
                            </Route>

                            {/* チェック結果発送 */}
                            <Route exact path={AppRouteHelper.checkResults()}>
                                <CheckResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.checkResultDetail()}>
                                <CheckResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.checkPostageSlips()}>
                                <CheckPostageSlipsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.testResultCheck()}>
                                <TestResultCheck />
                            </Route>

                            <Route>
                                <Error404Page />
                            </Route>
                        </Switch>
                    </Layout>
                </MasterDataContainer>
            </UserAuth>
        </>
    )

    const venderAppContent = (
        <>
            <UserAuth>
                <MasterDataContainer>
                    <Layout>
                        <Switch>
                            <Route exact path={AppRouteHelper.sendHistories()}>
                                <SendHistoriesPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewResults()}>
                                <PreviewResultPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewRequestList()}>
                                <PreviewRequestListPage />
                            </Route>
                            <Route exact path={AppRouteHelper.sendHistoriesPreviewRequestPostList()}>
                                <PreviewRequestPostListPage />
                            </Route>

                            <Route exact path={AppRouteHelper.naviResults()}>
                                <NaviResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.naviResultDetail()}>
                                <NaviResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.naviPostageSlips()}>
                                <NaviPostageSlipsPage />
                            </Route>

                            {/* ライト結果発送 */}
                            <Route exact path={AppRouteHelper.liteResults()}>
                                <LiteResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.liteResultDetail()}>
                                <LiteResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.litePostageSlips()}>
                                <LitePostageSlipsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.testResultLite()}>
                                <TestResultLite />
                            </Route>

                            {/* チェック結果発送 */}
                            <Route exact path={AppRouteHelper.checkResults()}>
                                <CheckResultsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.checkResultDetail()}>
                                <CheckResultDetailPage />
                            </Route>
                            <Route exact path={AppRouteHelper.checkPostageSlips()}>
                                <CheckPostageSlipsPage />
                            </Route>
                            <Route exact path={AppRouteHelper.testResultCheck()}>
                                <TestResultCheck />
                            </Route>

                            <Route>
                                <Error404Page />
                            </Route>
                        </Switch>
                    </Layout>
                </MasterDataContainer>
            </UserAuth>
        </>
    )
    return (
        <Switch>
            <Route exact path={AppRouteHelper.root()}>
                <LoginPage />
            </Route>
            <Route exact path={AppRouteHelper.login()}>
                <LoginPage />
            </Route>
            <Route path={'/'}>{process.env.REACT_APP_IS_VENDOR == 'true' ? venderAppContent : craifAppContent}</Route>
        </Switch>
    )
}

export default AppRoutes

/**
 * ルート定義
 */
export class AppRouteHelper {
    static basePath = (path: string): string => `/${path}`

    public static root = (): string => '/'
    // ログイン
    public static login = (): string => AppRouteHelper.basePath('login')

    public static dashboards = (): string => AppRouteHelper.basePath('dashboards')
    public static userSearch = (): string => AppRouteHelper.basePath('user_search')

    public static organizations = (): string => AppRouteHelper.basePath('organizations')
    public static institutions = (): string => AppRouteHelper.basePath('institutions')
    public static requestFormIssuances = (): string => AppRouteHelper.basePath('request_form_issuances')
    public static requestForms = (): string => AppRouteHelper.basePath('request_forms')
    public static previewRequestForm = (): string => AppRouteHelper.basePath('request_forms/:id/preview')
    public static previewRequestFormHomeTest = (): string => AppRouteHelper.basePath('request_forms/:id/preview_home_test')
    public static patients = (): string => AppRouteHelper.basePath('patients')
    public static doctors = (): string => AppRouteHelper.basePath('doctors')
    public static vendors = (): string => AppRouteHelper.basePath('vendors')

    public static samples = (): string => AppRouteHelper.basePath('samples')
    public static analyticsSamples = (): string => AppRouteHelper.basePath('analytics_samples')
    public static extractions = (): string => AppRouteHelper.basePath('extractions')
    public static pickingSamples = (): string => AppRouteHelper.basePath('extractions/picking')
    public static experimentSampleSheet = (): string => AppRouteHelper.basePath('experiment_sheet')
    public static dnaList = (): string => AppRouteHelper.basePath('dna')
    public static pcrRuns = (): string => AppRouteHelper.basePath('pcr_runs')
    public static pcrRun = (): string => AppRouteHelper.basePath('pcr_run/:id')
    public static pcrProcessLogs = (): string => AppRouteHelper.basePath('pcr_process_logs')
    public static pcrTestRuns = (): string => AppRouteHelper.basePath('pcr_test_runs')
    public static pcrTestResults = (): string => AppRouteHelper.basePath('pcr_test_runs/:id/results')
    public static pcrRunProtocolSheet = (): string => AppRouteHelper.basePath('pcr_runs/protocol_sheets')

    public static probes = (): string => AppRouteHelper.basePath('probes')
    public static probeLots = (): string => AppRouteHelper.basePath('probes/:id/probe_lots')
    public static probeStocks = (): string => AppRouteHelper.basePath('probe_stocks')
    public static stocktakings = (): string => AppRouteHelper.basePath('stocktakings')
    public static stocktakingItems = (): string => AppRouteHelper.basePath('stocktaking_items')
    public static orders = (): string => AppRouteHelper.basePath('orders')
    public static customerOrders = (): string => AppRouteHelper.basePath('customer_orders')
    public static homeProducts = (): string => AppRouteHelper.basePath('home_products')
    public static pcrProtocols = (): string => AppRouteHelper.basePath('pcr_protocols')

    public static printRequests = (): string => AppRouteHelper.basePath('print_requests')
    public static sendHistories = (): string => AppRouteHelper.basePath('send_histories')
    public static sendHistoriesPreviewResults = (): string => AppRouteHelper.basePath('send_histories/preview_results')
    public static sendHistoriesPreviewRequestList = (): string => AppRouteHelper.basePath('send_histories/preview_request_list')
    public static sendHistoriesPreviewRequestPostList = (): string => AppRouteHelper.basePath('send_histories/preview_request_post_list')

    public static inspectionTransportationReport = (): string => AppRouteHelper.basePath('inspections/transportation_reports')
    public static inspectionReceipt = (): string => AppRouteHelper.basePath('inspections/transportation_reports/receipt')
    public static inspectionInput = (): string => AppRouteHelper.basePath('inspections/transportation_reports/:id/input')
    public static inspectionConfirm = (): string => AppRouteHelper.basePath('inspections/transportation_reports/:id/confirm')
    public static requestFormErrors = (): string => AppRouteHelper.basePath('request_form_errors')

    public static freezers = (): string => AppRouteHelper.basePath('freezers')

    public static transcriptionHistories = (): string => AppRouteHelper.basePath('transcription_histories')

    public static productItems = (): string => AppRouteHelper.basePath('product_items')
    public static productSets = (): string => AppRouteHelper.basePath('product_sets')
    public static standardUrines = (): string => AppRouteHelper.basePath('standard_urines')
    public static scopedProductItems = (): string => AppRouteHelper.basePath('product_items/:scope/')
    public static qcSettings = (): string => AppRouteHelper.basePath('qc_settings')
    public static protocolVersions = (): string => AppRouteHelper.basePath('protocol_versions')
    public static tags = (): string => AppRouteHelper.basePath('tags')

    public static temperatureLedger = (): string => AppRouteHelper.basePath('ledger/temperature')
    public static trainingLedger = (): string => AppRouteHelper.basePath('ledger/training')
    public static trainingLedgerPaper = (): string => AppRouteHelper.basePath('ledger/training_ledger')
    public static groupTraining = (): string => AppRouteHelper.basePath('ledger/group_training')
    public static groupTrainingLedger = (): string => AppRouteHelper.basePath('ledger/group_training_ledger')
    public static trainingContents = (): string => AppRouteHelper.basePath('ledger/training/contents')

    public static sales = (): string => AppRouteHelper.basePath('sales')
    public static salesDashboard = (): string => AppRouteHelper.basePath('sales/dashboard')
    public static salesAgencies = (): string => AppRouteHelper.basePath('sales_agencies')
    public static invoices = (): string => AppRouteHelper.basePath('invoices')
    public static salesAgencyPayment = (): string => AppRouteHelper.basePath('sales_agencies/payment')
    public static coupons = (): string => AppRouteHelper.basePath('coupons')
    public static couponCodeHistories = (): string => AppRouteHelper.basePath('coupons/:id/histories')
    public static previewCouponCode = (): string => AppRouteHelper.basePath('coupons/:id/codes')
    public static materials = (): string => AppRouteHelper.basePath('materials')
    public static discounts = (): string => AppRouteHelper.basePath('discounts')

    public static reportCtChart = (): string => AppRouteHelper.basePath('reports/ct_charts')

    public static equipments = (): string => AppRouteHelper.basePath('equipments')
    public static equipmentCategories = (): string => AppRouteHelper.basePath('equipment_categories')
    public static disposalLedger = (): string => AppRouteHelper.basePath('ledgers/disposal_samples')
    public static requestFormErrorsLedger = (): string => AppRouteHelper.basePath('ledgers/request_form_errors')
    public static reagentsLedger = (): string => AppRouteHelper.basePath('ledgers/reagents')
    public static maintenanceLedgers = (): string => AppRouteHelper.basePath('ledgers/maintenance_ledgers')
    public static qcLedgers = (): string => AppRouteHelper.basePath('ledgers/qc')
    public static qcLedger = (): string => AppRouteHelper.basePath('ledgers/qc/:id')
    public static checkInLedger = (): string => AppRouteHelper.basePath('ledger/check_in')
    public static receiveLedger = (): string => AppRouteHelper.basePath('ledger/receive')
    public static measureLedger = (): string => AppRouteHelper.basePath('ledger/measure')
    public static measureLedgerPaper = (): string => AppRouteHelper.basePath('ledger/measure_ledger')

    public static reagents = (): string => AppRouteHelper.basePath('reagents')
    public static reagentItems = (): string => AppRouteHelper.basePath('reagent_items')

    public static taskMasterSets = (): string => AppRouteHelper.basePath('task_master_sets')
    public static taskSets = (): string => AppRouteHelper.basePath('task_sets')
    public static tasks = (): string => AppRouteHelper.basePath('tasks')
    public static taskGroups = (): string => AppRouteHelper.basePath('task_groups')
    public static materialTasks = (): string => AppRouteHelper.basePath('tasks/materials')
    public static printMaterialTask = (): string => AppRouteHelper.basePath('tasks/materials/print')

    public static testResultV2 = (): string => AppRouteHelper.basePath('tests/result_v2')

    public static naviResults = (): string => AppRouteHelper.basePath('navi/results')
    public static naviResultDetail = (): string => AppRouteHelper.basePath('navi/results/preview')
    public static naviPostageSlips = (): string => AppRouteHelper.basePath('navi/results/postage_slips')

    public static liteResults = (): string => AppRouteHelper.basePath('lite/results')
    public static liteResultDetail = (): string => AppRouteHelper.basePath('lite/results/preview')
    public static litePostageSlips = (): string => AppRouteHelper.basePath('lite/results/postage_slips')
    public static testResultLite = (): string => AppRouteHelper.basePath('tests/result_lite')

    public static checkResults = (): string => AppRouteHelper.basePath('check/results')
    public static checkResultDetail = (): string => AppRouteHelper.basePath('check/results/preview')
    public static checkPostageSlips = (): string => AppRouteHelper.basePath('check/results/postage_slips')
    public static testResultCheck = (): string => AppRouteHelper.basePath('tests/result_check')
}
